//this file is being processed by the build-env.js to replace process.env_SOME_VARIABLE with its string or object value

export const environment = {
  environmentAlias: "prod",
  firebaseConfig: {"apiKey":"AIzaSyBmjDI4MmsexOlbLd4Q9G16_VJre40nCfY","appId":"1:942289292498:web:509ef39e43338ab992310b","authDomain":"ball-score-2-broadcast.firebaseapp.com","databaseURL":"https://ball-score-2-broadcast-default-rtdb.firebaseio.com","messagingSenderId":"942289292498","projectId":"ball-score-2-broadcast","storageBucket":"ball-score-2-broadcast.appspot.com"},
  release: "ball-score@2.24.1+build.2026-10-08T16-16-23",
};
